import { SupportMessageTags } from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Button } from 'react-bootstrap';
import ContactForm from '../../contactForm/ContactForm';
import { HelpBooking } from '../SelectBooking';

export default function CancelChangeDatesOptions({
  booking,
  type,
  userID,
}: {
  userID: string;
  booking: HelpBooking;
  type: 'cancel' | 'changeDates';
}) {
  // Check active
  const isActive = booking.spaces.some((space) => space.active === true);

  if (!isActive) {
    return (
      <div className="mt-3">
        <h2 className="h4">
          All the spaces on this booking are already cancelled
        </h2>

        <p>
          If you were offered a refund previously, these typically take 3-5
          working days. If you need to contact Skyhook directly, please use the
          form below:
        </p>

        <ContactForm
          defaultSubject={`${
            type === 'cancel' ? 'Cancel' : 'Change dates'
          } - Booking ${booking.id}`}
          hideTitle
          tags={[
            type === 'cancel'
              ? SupportMessageTags.CANCELLATION
              : SupportMessageTags.CHANGE_DATES,
          ]}
        />
      </div>
    );
  }

  const header =
    type === 'cancel'
      ? 'Sorry you need to cancel!'
      : "Here's how to change dates";

  if (!booking.isOwner) {
    return (
      <div className="mt-3">
        <h2 className="h4">{header}</h2>

        <p>
          You're registered as a guest on this booking, rather than the owner.
        </p>

        <p>
          As you are the guest, you'll need to reach out to the person who made
          the booking, and ask them to do this for you.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-3">
      <h2 className="h4">{header}</h2>

      <p>
        You can see your options with the link below, and then click "confirm"
        on the next screen if you wish to go ahead.
      </p>

      <Link href={`/me/${userID}/bookings/${booking.id}/cancel`} legacyBehavior>
        <Button className="mb-2 me-2">Cancel</Button>
      </Link>

      <p className="mt-4">
        Please note that we can't generally offer exceptions to our standard
        policies, and the link above will explain this in more detail. However
        if you do need to contact Skyhook support directly, you can do that with
        the contact form below.
      </p>

      <ContactForm
        defaultSubject={`${
          type === 'cancel' ? 'Cancel' : 'Change dates'
        } - Booking ${booking.id}`}
        hideTitle
        tags={[
          type === 'cancel'
            ? SupportMessageTags.CANCELLATION
            : SupportMessageTags.CHANGE_DATES,
        ]}
      />
    </div>
  );
}
